import { ContentAction } from './actions';
import { IContentState } from './hook';

export const ContentReducer = (state: IContentState, action: ContentAction): IContentState => {
  switch (action.type) {
    case 'CONFIG':
      return { ...state, service: action.payload };
    case 'SITEMAP':
      return {
        ...state,
        content: { ...state.content, siteMap: action.payload },
      };
    case 'HEADER':
      return {
        ...state,
        content: { ...state.content, header: action.payload },
      };
    case 'FOOTER':
      return {
        ...state,
        content: { ...state.content, footer: action.payload },
      };
    case 'NOTIFICATION':
      return {
        ...state,
        content: { ...state.content, notification: action.payload },
      };
    case 'PAGE':
      return {
        ...state,
        content: { ...state.content, page: action.payload },
      };
    case 'CART':
      return {
        ...state,
        content: { ...state.content, cart: action.payload },
      };
    default:
      return state;
  }
};
